console.log('CraftCMS 5 Starter loaded');

// Add your custom JavaScript here

import '@fontsource-variable/google-sans-flex';

import './components/nav';
import './components/chart';
import './components/reports';
import './components/swiper';
import './components/tabs';

import { createApp, defineAsyncComponent } from 'vue';

if (document.getElementById('contactForm')) {
    createApp({})
        .component('fc-contact-form',
            defineAsyncComponent(() => import('./components/ContactForm.vue')))
        .mount('#contactForm');
}